export const getTenantCountryId = (tenant) => tenant?.country?.id ?? ''

export const getCountryPreferenceValue = (tenantInputs) =>
  tenantInputs?.country?.id
